import { SEND_OTP } from '../api'
import axios from 'axios'

const sendOtp = async (phoneNumber, login = true) => {
    try {
        const ut = 'customer'
        const payload = { phoneNumber, login, ut }
        return await axios.post(SEND_OTP, payload)
    } catch (error) {
        return { success: false, error: error.message }
    }
}

export default sendOtp
